import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Leaf, ShieldCheck, Users } from "lucide-react";
import { ASSETS } from "../lib/constants";

export default function Mission() {
  const { t } = useTranslation();
  return (
    <section data-testid="mission-page" className="relative bg-brand-black py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="md:col-span-5 order-2 md:order-1"
          >
            <div className="aspect-[4/5] overflow-hidden border-2 border-brand-orange hard-shadow">
              <img src={ASSETS.lifestyle2} alt="" className="h-full w-full object-cover" />
            </div>
          </motion.div>

          <div className="md:col-span-7 order-1 md:order-2">
            <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-brand-orange">
              {t("nav.mission")}
            </span>
            <h1 className="mt-2 font-display text-5xl uppercase leading-[0.95] sm:text-6xl lg:text-7xl">
              {t("mission.title")}
            </h1>
            <p className="mt-6 text-xl leading-relaxed text-white/85">{t("mission.lead")}</p>

            <div className="mt-10 space-y-4">
              {[
                { icon: <Leaf />, title: t("mission.v1Title"), body: t("mission.v1Body") },
                { icon: <ShieldCheck />, title: t("mission.v2Title"), body: t("mission.v2Body") },
                { icon: <Users />, title: t("mission.v3Title"), body: t("mission.v3Body") },
              ].map((c, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.08 }}
                  className="flex items-start gap-4 border-l-4 border-brand-orange bg-white/[0.03] p-4"
                >
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center bg-brand-orange text-white">
                    {c.icon}
                  </div>
                  <div>
                    <h3 className="font-display text-2xl uppercase">{c.title}</h3>
                    <p className="text-sm text-white/75">{c.body}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
